import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const parseHourToMinutes = (data: string) => {
  if (data.length !== 4) return null;
  const hour = parseInt(data.substring(0, 2));
  const minute = parseInt(data.substring(2, 4));
  if (Number.isNaN(hour) || Number.isNaN(minute)) return null;
  return hour * 60 + minute;
};

export const isValidHour = (data: string) => {
  const minutes = parseHourToMinutes(data);
  if (minutes === null) return false;
  const hour = Math.floor(minutes / 60);
  const minute = minutes % 60;
  return hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59;
};

export const isArrivalAfter15 = (data: string) => {
  const minutes = parseHourToMinutes(data);
  if (minutes === null) return false;
  return minutes >= 15 * 60;
};

export const isCheckoutBefore11 = (data: string) => {
  const minutes = parseHourToMinutes(data);
  if (minutes === null) return false;
  return minutes <= 11 * 60;
};

export const useArrivalAndDepartureSchema = () => {
  const { t } = useTranslation();

  const schema = z.object({
    arrivalHour: z.string({ required_error: t('checkin.arrivalAndDepartureTime.forms.errors.checkinTime') })
      .nonempty({
        message: t('checkin.arrivalAndDepartureTime.forms.errors.checkinTime'),
      })
      .refine(isValidHour, {
        message: t('checkin.arrivalAndDepartureTime.forms.errors.invalidHour'),
      })
      .refine((value) => !isValidHour(value) || isArrivalAfter15(value), {
        message: t('checkin.arrivalAndDepartureTime.forms.errors.checkinAfter15'),
      }),
    departureHour: z.string({ required_error: t('checkin.arrivalAndDepartureTime.forms.errors.checkoutTime') })
      .nonempty({
        message: t('checkin.arrivalAndDepartureTime.forms.errors.checkoutTime'),
      })
      .refine(isValidHour, {
        message: t('checkin.arrivalAndDepartureTime.forms.errors.invalidHour'),
      })
      .refine((value) => !isValidHour(value) || isCheckoutBefore11(value), {
        message: t('checkin.arrivalAndDepartureTime.forms.errors.checkoutBefore11'),
      }),
    accept: z.boolean({ required_error: t('checkin.arrivalAndDepartureTime.forms.errors.accept') })
  }).superRefine((data, context) => {

  }
  );


  return schema;
};
